import Subject from "../cse4sub/Subject";
import React from 'react'
//import csm from '../assets/CSE502mid21.pdf'
import cse from '../assets/CSE502end21.pdf'
import csm from '../assets/cse502mid21.pdf'
export default function Daa() {
  return (
    <div>
       <Subject title="Design & Analysis Algorithms(CSE502)" sub="DAA" syllabus="#"mid="Q. Paper"
    book1="Introduction to Algorithms,3rd Edition, T.H.Cormen, CE.Leiserson, RL.Rivest, and Clifford Stein, 
    published by PHI" 
    book2="Fundamental of Compter Algorithms, 2nd Edition, E. Horowitz, S. Sahni, and S. Rajasekaran, published 
    by Universities Press  "
    book1Link="https://www.pdfdrive.com/download.pdf?id=101300109&h=96fbade78df2ad562c940a88212f655b&u=cache&ext=pdf" 
    book2Link="https://www.pdfdrive.com/download.pdf?id=18723362&h=958298a6641599f3a4805226c25ec3ad&u=cache&ext=pdf"
     int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}